import { observer } from 'mobx-react-lite';

import { useUserStore } from '@/configs/store';

import { CommentForm } from '../CommentForm';
import { CommentItem } from '../CommentItem';
import { IssueCardStore } from '../../model/IssueCardStore';

import s from './CommentList.module.scss';

type Props = {
  store: IssueCardStore;
};

/** Комментарии задачи: поле нового сверху, затем сначала новые — как в Яндекс Трекере */
const CommentList: React.FC<Props> = observer(({ store }) => {
  const { user, isAdmin } = useUserStore();

  return (
    <div className={s.comments}>
      {!store.isReadOnly && <CommentForm store={store} />}
      {/* API отдаёт по `createTime asc` */}
      <ul className={s.list}>
        {[...store.comments].reverse().map((comment) => {
          const isAuthor = comment.author.id === user?.id;

          return (
            <CommentItem
              key={comment.id}
              comment={comment}
              store={store}
              canEdit={isAuthor && !store.isReadOnly}
              canDelete={(isAuthor || isAdmin) && !store.isReadOnly}
            />
          );
        })}
      </ul>
    </div>
  );
});

export { CommentList };
